import { Button, Card, CircularProgress, Grid, InputLabel, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadPdf } from '../../../components';
import { getDetailLaporanKeuangan, updLaporanKeuangan } from '../../../redux/actions/LaporanKeuanganActions';

const EditLaporanKeuangan = () => {
    const { id } = useParams();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        rfs_code: "",
        year: "",
        quarter_id: "",
        quarter_en: "",
        date: "",
        file: "",
        file_old: "",
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updLaporanKeuangan(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const getData = useCallback(() => {
        setLoading(true);
        getDetailLaporanKeuangan(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        rfs_code: data?.rfs_code,
                        year: data?.year,
                        quarter_id: data?.quarter_id,
                        quarter_en: data?.quarter_en,
                        date: data?.date,
                        file: "",
                        file_old: data?.file_ori,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data laporan keuangan, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data laporan keuangan, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            rfs_code: id
        }));
        getData();
    }, [getData, id]);
    const handleChangeFile = (file, path) => {
        setParams(pref => ({
            ...pref,file
        }))
    }
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Laporan Keuangan</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="quarter_id"
                                            className="mb-4"
                                        >
                                            Judul [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="quarter_id"
                                            placeholder="Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="quarter_id"
                                            value={params.quarter_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="quarter_en"
                                            className="mb-4"
                                        >
                                            Judul [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="quarter_en"
                                            placeholder="Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="quarter_en"
                                            value={params.quarter_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md="6">
                                        <InputLabel htmlFor="year" className="mb-4">
                                            Tahun{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <TextValidator
                                            id="year"
                                            placeholder="Tahun"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="number"
                                            name="year"
                                            value={params.year || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Tahun terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md="6">
                                        <InputLabel htmlFor="date" className="mb-4">
                                            Tanggal{' '}
                                            <span className="text-danger">*</span>
                                        </InputLabel>
                                        <TextValidator
                                            id="date"
                                            placeholder="Tahun"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="date"
                                            name="date"
                                            value={params.date || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Tanggal terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <UploadPdf
                                            uploadFile={handleChangeFile}
                                            label="Unggah berkas"
                                            preview={
                                                params?.file
                                            }
                                            note={[
                                                'Format PDF diperbolehkan',
                                                "Upload ulang jika Anda ingin mengganti file yang sudah diupload"
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default EditLaporanKeuangan;
